import { Grid } from "@mui/material";
import { Labeled, ReferenceField, TextField } from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { erasmusRequests } from "api/erasmusApi";
import { studentRequests } from "api/studentApi";

const InfoSection = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={3}
      >
        <Labeled label="Име">
          <TextField source="name" />
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <Labeled label="Учебна година">
          <ReferenceField
            source="academicYearId"
            reference={studentRequests.getAcademicYearsSelect()}
          >
            <TextField source="name" />
          </ReferenceField>
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <Labeled label="Структурна единица">
          <ReferenceField
            source="structuralUnitId"
            reference={administrationRequests.getStructuralUnitsSelect()}
          >
            <TextField source="name" />
          </ReferenceField>
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <Labeled label="Сезон">
          <ReferenceField
            source="campaignSeason"
            reference={erasmusRequests.getCampaignSeasonsSelect()}
          >
            <TextField source="nameBg" />
          </ReferenceField>
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default InfoSection;
